import * as React from 'react';
import * as styles from './styles.css';

export interface ISectionProps {
  marginTop?: number;
  marginBottom?: number;
  children: React.ReactNode | React.ReactNode[];
}

/** Проблема: рендерит обертку div, даже если дочерний элемент внутри себя возвращает null.
 * приводит к тому, что в DOM бывают пустые div’ы */
export const Section = React.forwardRef<HTMLDivElement, ISectionProps>(({ marginTop, marginBottom, children }, ref) => {
  return (
    <div ref={ref} className={styles['container']} style={{ marginTop, marginBottom }}>
      {children}
    </div>
  );
});

Section.displayName = 'Section';
